__webpack_require__.p = "/shared-mailbox-ff-cleanup/referrals-hub/";